import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[200px] flex items-center justify-center p-6">
          <div className="text-center space-y-3">
            <AlertTriangle className="w-10 h-10 text-destructive mx-auto" />
            <h2 className="text-lg font-semibold font-display">Bir hata oluştu</h2>
            <p className="text-sm text-muted-foreground max-w-sm">
              {this.props.fallbackMessage || 'Beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin.'}
            </p>
            <Button
              variant="outline"
              className="rounded-xl"
              onClick={() => {
                this.setState({ hasError: false, error: null });
                if (this.props.onRetry) this.props.onRetry();
                else window.location.reload();
              }}
            >
              <RefreshCw className="w-4 h-4 mr-2" /> Tekrar Dene
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
